import _ from 'underscore';
import platformUtilities from '../../modules/platform_utilities.js';
import WaterfallHelper from '../../modules/waterfall_helper.js';
import WaterfallModalHelper from '../../modules/waterfall_modal_helper.js';

angular.module('vastdesk').
  component('campaignCampaignTiers',  {
    bindings: {
      setCampaignTiers: '<',
      editable: '<',
      batchActions: '<',
      campaignId: '<',
      modalPath: '@',
      partnerTierOverrideEnabled: '<',
      partnerTierOverride: '@',
      costModelType: '<',
      hasRate: '<',
      demandPartnerId: '@',
      currencyPlaceholder: '@',
      forecast: '<'
    },
    template: require("../templates/campaignCampaignTiers.html"),
    controllerAs: '$campaignCampaignTiersCtrl',
    controller: ['$scope', '$rootScope', function($scope, $rootScope) {

      var self = this;

      this.selectedIds = [];
      this.selectedSupplyTagBulkActionIds = [];
      var waterfallModalHelper = new WaterfallModalHelper();
      var serverSideTable = $('#tag_results table');
      var serverSideTableId = $(serverSideTable).attr('id');
      var serverSideDataTable;
      var modal = $('#supply_modal');
      var modalTable = $('#supply_modal table');
      var modalTableLoaded = $.Deferred();
      var bodySelector = $('body');
      var filteredSetCampaignTiers = [];
      var reportData = [];
      var supplyPartnerIdsInWaterfall = [];
      var serverSideTableLoaded = false;
      var waterfallHelper = new WaterfallHelper();

      this.setCampaignTierUniqIdFor = function(setCampaignTier) {
        return waterfallHelper.setDemandTagPriorityUniqIdFor(setCampaignTier, 'supply_tag_id');
      };

      serverSideTable.on('init.dt', function() {
        serverSideDataTable = $(this).DataTable();
        waterfallHelper.addDateRangeSelect({forecast: self.forecast});

        if (Array.isArray(reportData) && reportData.length > 0) {
          setTimeout(function() {
            waterfallHelper.drawServerSideTable(serverSideDataTable, false);
          }, 0);
        }
      });

      serverSideTable.on('preXhr.dt', function (e, settings, data) {
        waterfallHelper.abortPendingAjaxRequests(serverSideTable, serverSideDataTable);

        data.demand_partner_id = self.demandPartnerId;
        data.set_campaign_tiers = self.setCampaignTiers;
        data.date_range = $('#date_range').val();
        data.report_data = waterfallHelper.getSupplyTagReportDataForDraw(serverSideTable, serverSideDataTable, reportData);
        data.custom_data = data.custom_data || {};
        data.custom_data.selected_ids = self.selectedSupplyTagBulkActionIds;
      });

      serverSideTable.on('xhr.dt', function(e, settings, json, xhr) {
        if (json && json.custom_data) {
          serverSideTableLoaded = true;
          filteredSetCampaignTiers = json.custom_data.filtered_set_campaign_tiers;
          supplyPartnerIdsInWaterfall = json.custom_data.supply_partner_ids;
          waterfallHelper.filterPartners(serverSideTable, serverSideTableLoaded, supplyPartnerIdsInWaterfall);
        }
        if (json && json.data) {
          attachReportData(json.data);
        }
      });

      serverSideTable.on('init.filter.ss.dt', function(e, filterId) {
        if (filterId === 'dfilter_partner') {
          setTimeout(function() {
            waterfallHelper.filterPartners(serverSideTable, serverSideTableLoaded, supplyPartnerIdsInWaterfall);
          }, 0);
        }
      });

      $scope.$on('updatingReportData', function(e, args) {
        if (args.table === serverSideTableId) {
          platformUtilities.triggerDataTablesProcessing(serverSideTable, true);
        }
      });

      $scope.$on('updatedReportData', function(e, args) {
        if (args.table === serverSideTableId) {
          reportData = args.resp.supply_tag_report;
          self.currencyPlaceholder = args.resp.currency_placeholder;
          waterfallHelper.drawServerSideTable(serverSideDataTable, false);
        }
      });

      $scope.$on('bulkEditBroadcast', function(e, args) {
        if (args.tableId === serverSideTableId) {
          if (!args.selectedIds || !Array.isArray(args.selectedIds)) {
            return;
          }

          var supplyTagIds = _.map(args.selectedIds, function(id) {
            return parseInt(id);
          });

          if (args.id === 'remove') {
            removeSetCampaignTiers(supplyTagIds, false, {
              allSlots: true
            });
          }
          else if (args.id === 'tier') {
            handleBulkChange(supplyTagIds, 'tier', parseInt(args.value));
          }
        }
      });

      // demandPartnerIdChange, costModelTypeChange, hasRateChange
      _.each(['demandPartnerId', 'costModelType', 'hasRate'], function(attr) {
        $rootScope.$on(attr + 'Change', function(e, args) {
          self[attr] = args[attr];
        });
      });

      $rootScope.$on('copySupplyFromCampaignSubmit', function(e, args) {
        var params = _.extend({}, args.params, {
          supply_tag_ids: currentSupplyTagIds(),
          current_campaign_id: self.campaignId
        });

        $.post(args.path, params, function(resp) {
          addSetCampaignTiers(resp);
        });
      });

      $scope.$on('partnerTierFieldsChange', function(e, args) {
        self.partnerTierOverrideEnabled = args.partnerTierOverrideEnabled;
        self.partnerTierOverride = args.partnerTierOverride;
      });

      var campaignTierWithSupplyTagIdAndSlot = function(campaignTiers, id, slotOrder, slotNumber) {
        return _.find(campaignTiers, function(sct) {
          return parseInt(sct.supply_tag_id) === parseInt(id) && waterfallHelper.inSlot(sct, slotOrder, slotNumber);
        });
      };

      var setCampaignTierFor = function(row) {
        var id = dataAttributeForRow(row, 'supplyTagId');
        var slotOrder = dataAttributeForRow(row, 'so');
        var slotNumber = dataAttributeForRow(row, 'sn');
        return campaignTierWithSupplyTagIdAndSlot(self.setCampaignTiers, id, slotOrder, slotNumber);
      };

      var updateSetCampaignTier = function(row, attributes, draw) {
        var sct = setCampaignTierFor(row);

        if (sct) {
          sct = _.extend(sct, attributes);
          $scope.$apply();

          if (draw) {
            waterfallHelper.drawServerSideTable(serverSideDataTable, false);
          }
        }
      };

      var updateSetCampaignTierFromElement = function(element, attribute, draw) {
        var row = waterfallHelper.rowForTableElement(element);
        var attributes = {};
        attributes[attribute] = waterfallHelper.valueForElement(element, attribute);
        updateSetCampaignTier(row, attributes, draw);
      };

      var handleBulkChange = function(supplyTagIds, attribute, value) {
        _.each(self.setCampaignTiers, function(sct) {
          if (_.includes(supplyTagIds, parseInt(sct.supply_tag_id))) {
            sct[attribute] = value;
          }
        });

        setTimeout(function() {
          $scope.$apply();
        }, 0);

        waterfallHelper.drawServerSideTable(serverSideDataTable, false);
      };

      bodySelector.on('change', 'td .ct-t', function () {
        updateSetCampaignTierFromElement(this, 'tier', true);
      });

      bodySelector.on("click", "form.tag-form a.remove-tag", function(){
        var row = waterfallHelper.rowForTableElement(this);
        var supplyTagId = dataAttributeForRow(row, 'supplyTagId');

        removeSetCampaignTiers([supplyTagId], true, {
          slotOrder: dataAttributeForRow(row, 'so'),
          slotNumber: dataAttributeForRow(row, 'sn')
        });

        return false;
      });

      bodySelector.on('click', '.remove-all', function(e){
        removeAllFilteredSetCampaignTiers();
        return false;
      });

      modalTable.on('init.dt', function () {
        modalTableLoaded.resolve();
      });

      modalTable.on('preXhr.dt', function(e, settings, data) {
        data.cost_model_type = self.costModelType;
        data.has_rate = self.hasRate;
        data.custom_data = data.custom_data || {};
        data.custom_data.selected_ids = [].concat(currentSupplyTagIds()).concat(self.selectedIds);
      });

      modalTable.on('draw.dt', function () {
        _styleModalRows();
        waterfallModalHelper.setSelectedModalCheckboxes(modalTable, self.selectedIds);
        waterfallHelper.setModalCheckboxes(modalTable, currentSupplyTagIds());
      });

      var _styleModalRows = function (){
        var bulkIndex = modalTable.find("th.bulk-add-enabled").index();
        var statusIndex = modalTable.find("th.status").index();

        modalTable.find("tr").each(function(i, tr) {
          waterfallModalHelper.styleWithBulkAddEnabled(tr, bulkIndex);
          waterfallModalHelper.styleStatus(tr, statusIndex);
        });
      };

      bodySelector.on('submit', '#copy_form', function(){
        var copyForm = $(this);
        var path = copyForm.attr('action');
        var campaignId = copyForm.find('#copy_campaign_id').val();
        var params = {
          campaign_id: campaignId,
          demand_partner_id: self.demandPartnerId
        };

        $rootScope.$broadcast('copySupplyFromCampaignSubmit', {
          path: path,
          params: params
        });

        $('#copy_campaign_id').val('');
        $('#copy_campaign_name').val('');
        $('#copy_save').attr('disabled', true);
        $('#copy_modal').modal('hide');
        return false;
      });

      $("#copy_campaign_name").autocomplete({
        minLength: 1,
        source: function( request, response ) {
          $.ajax({
            url: "/searches/campaigns?text_only=true&exclude_open_market=true&search="+request.term,
            dataType: "json"
          }).done(function( data ) {
            response(
              _.chain(data)
               .map(function(item) {
                 return {
                   label: item.text,
                   value: item.value
                 };
               })
               .reject(function(item) {
                 return item.value == self.campaignId;
               })
               .value()
            );
          });
        },
        select: function(e, ui){
          var item = ui.item;
          var itemId = item.value;
          $("#copy_campaign_name").val($('<div></div>').html(item.label).text());
          $("#copy_campaign_id").val(itemId);
          $("#copy_save").removeAttr("disabled");
          return false;
        }
      }).data("ui-autocomplete")._renderItem = function (ul, item) {
         return $("<li></li>")
             .data("item.autocomplete", item)
             .append(item.label)
             .appendTo(ul);
       };

      bodySelector.on('click', '.open-tag-modal', function (e) {
        if ($(this).attr('disabled')) {
          e.preventDefault();
          return false;
        }
        self.selectedIds = [];
      });

      var _setFloorRpmFilter = function () {
        var filterVal = '';
        var rateVal = $('#campaign_rate').val();
        var rate = platformUtilities.cleanParseFloat(rateVal);
        if (rate && self.costModelType === 0 && self.hasRate) {
          filterVal = rate.toFixed(2);
        }
        modal.find("#dfilter_rpm_floor").val(filterVal).trigger("keyup");
        modal.find('#dfilter_min_rpm_floor').val('').trigger("keyup");
      };

      waterfallModalHelper.openEventHandler(bodySelector, '.open-tag-modal', modal, modalTable, function() {
        $.when( modalTableLoaded ).done(function() {
          _setFloorRpmFilter();
          modal.find('.modal-content .dataTables_filter input').attr("placeholder", "Search by tag or partner name, or enter a comma-separated list of IDs...");
        });
      });

      waterfallModalHelper.modalCheckEventHandler(bodySelector, 'tag_ids', function(val) {
        self.selectedIds.push(val);
      }, function(val) {
        self.selectedIds = _.without(self.selectedIds, val);
      });

      waterfallModalHelper.saveEventHandler(bodySelector, modal, modalTable, function() {
        var path = $('#tag_results').data('ssTableRowsPath');
        var params = {
          demand_partner_id: self.demandPartnerId,
          object_ids: self.selectedIds
        };

        if (self.partnerTierOverrideEnabled) {
          params["partner_tier_override"] = self.partnerTierOverride;
        }

        $.post(path, params, function(resp) {
          addSetCampaignTiers(resp);
        });
      });

      var dataAttributeForRow = function(row, attribute) {
        return $(row).data(attribute);
      };

      var removeAllFilteredSetCampaignTiers = function() {
        self.setCampaignTiers = _.reject(self.setCampaignTiers, function(sct) {
          return _.find(filteredSetCampaignTiers, function(fsct) {
            return parseInt(sct.supply_tag_id) === parseInt(fsct.supply_tag_id) && waterfallHelper.inSlot(sct, fsct.slot_order, fsct.slot_number);
          });
        });
        $scope.$apply();
        waterfallHelper.drawServerSideTable(serverSideDataTable, true);
      };

      var reportRowFor = function(tableRow) {
        return _.find(reportData, function(reportRow) {
          return reportRow.supply_tag_id === tableRow.DT_RowAttr['data-supply-tag-id'] &&
            waterfallHelper.inSlot(reportRow, tableRow.DT_RowAttr['data-so'], tableRow.DT_RowAttr['data-sn']);
        }) || {};
      };

      var attachReportData = function(rows) {
        _.each(rows, function(r) {
          var reportRow = reportRowFor(r);
          waterfallHelper.addReportDataToRow(r, reportRow, {
            currencyPlaceholder: self.currencyPlaceholder
          });
        });
      };

      var currentSupplyTagIds = function() {
        return waterfallHelper.extractIdsFromSetList(self.setCampaignTiers, 'supply_tag_id');
      };

      var addSetCampaignTiers = function(resp) {
        if (!resp.rows) {
          return;
        }

        var currentIds = currentSupplyTagIds();

        var validNewCampaignTiers = _.reject(resp.rows, function(ct) {
          return _.includes(currentIds, parseInt(ct.supply_tag_id));
        });

        self.setCampaignTiers = self.setCampaignTiers.concat(validNewCampaignTiers);
        $scope.$apply();
        waterfallHelper.drawServerSideTable(serverSideDataTable, false);
      };

      var removeSetCampaignTiers = function(supplyTagIds, applyScope, slotOptions) {
        var startingLength = self.setCampaignTiers.length;

        self.setCampaignTiers = _.reject(self.setCampaignTiers, function(sct) {
          return _.includes(supplyTagIds, parseInt(sct.supply_tag_id)) && (slotOptions.allSlots || waterfallHelper.inSlot(sct, slotOptions.slotOrder, slotOptions.slotNumber));
        });

        var endingLength = self.setCampaignTiers.length;
        var tagsRemoved = startingLength - endingLength;

        if (tagsRemoved < 1) {
          return;
        }

        if (applyScope) {
          $scope.$apply();
        }

        waterfallHelper.drawServerSideTableAfterRemoval(serverSideDataTable, tagsRemoved);
      };

      var intervalTime = 0;
      setInterval(function () {
        intervalTime += 1;
        if(intervalTime >= 60 && document.hasFocus() && $("#tabSupply").is(".active")){
          $rootScope.$broadcast('updateReportData', {table: serverSideTableId});
          intervalTime = 0;
        }
      }, 1000);

    }]
});
